export default function FlexSpacer() {
  return <span className="flex-grow">&nbsp;</span>;
}
